import {UUID} from "node:crypto";

enum NewsCategory {
    EVENT = "EVENT",
    CONFERENCE = "CONFERENCE",
    UPDATE = "UPDATE",
    NEW_VERSION = "NEW_VERSION",
}

interface News{
    id: string,
    title: string,
    category: NewsCategory,
    description: string,
    content: string,
    modificationDate: Date
}

export {NewsCategory}
export type {News}